import {easeInCubicFollow} from 'modules/ease.js';

export default function () {

    return easeInCubicFollow;
};
